module.exports = [
    { 
        name: 'bms', 
        entry: '/bms',
        container: '#instance', 
        activeRule: '/bms',
        active: true 
    }, { 
        name: 'saas', 
        entry: '/saas', 
        container: '#instance', 
        activeRule: '/saas' 
    }
]